<div class="max-h-180">
  <div class="mb-2 grid grid-cols-1 gap-5">
    <div class="flex flex-col">
      <aux-download-template-button
        [templateType]="siteTemplateType"
        [showIcon]="false"
        label="Download the template"
        class="mb-4 flex justify-start"
      />
      <aux-file-manager
        #bulkFileManager
        class="h-48"
        [fetchFilesOnInit]="false"
        [path]="path"
        [eager]="false"
        [showSuccessOnUpload]="true"
      />
    </div>

    @if (bulkFiles$ | async; as bulkFiles) {
      @if (bulkFiles?.length) {
        <div class="mt-4 grid grid-cols-12">
          <div class="col-span-12 pb-2 text-xs">Uploaded Files</div>

          @for (bulkFile of bulkFiles; track bulkFile) {
            <ng-container class="border-b">
              <div class="col-span-11 flex items-center break-all border-b p-2">
                {{ bulkFile.fileName }}
              </div>

              <div class="flex justify-end border-b">
                <button class="p-2" (click)="removeBulkFile(bulkFile)">
                  <aux-icon name="Trash" class="text-aux-error" />
                </button>
              </div>
            </ng-container>
          }
        </div>
      }
    }

    @if (errorMessage()) {
      <div class="mt-4 rounded-md bg-aux-error p-5 font-medium text-white">
        {{ errorMessage() }}
      </div>
    }
  </div>
</div>
